import { IAsset } from '@models/assets/request';
import { ISpecialHours } from '@models/schedule/specialHours';
import { IBusinessHoursWithStrings } from '@models/schedule/time-schedule';

import { RankingAnalyticsEntry } from './location';

// FIND
export type IFindLocationResponse = IFindLocationResponseElement[];

export interface IFindLocationResponseElement {
  id: number;
  name: string;
  latitude: string;
  longitude: string;
  createdAt: string;
  primary: boolean;
  city: string;
  countryIso: string;
  stateName: string;
  street: string;
}

// FIND ONE
export interface IFindOneLocationResponse {
  id: number;
  name: string;
  categoryId: number;
  city: string;
  countryIso: string;
  postalCode: string;
  stateIso: string;
  stateName: string;
  street: string;
  latitude: string;
  longitude: string;
  phone: string;
  description: string;
  businessHours: IBusinessHoursWithStrings;
  photos: IAsset[];
  createdAt: string;
  primary: boolean;
  hideAddress: boolean;
  franchise: boolean;
  bizUrl?: string;
  specialHours?: ISpecialHours[];
  // Phantom-location lifecycle (GET /v1/locations/:id is phantom-safe):
  // - synupLocationId === null → phantom, not yet completed (all Synup-derived fields null).
  // - googlePlaceId === null → no GMB linked yet.
  synupLocationId: string | null;
  googlePlaceId: string | null;
}

// CREATE & UPDATE
export interface ICreateUpdateLocationResponse {
  id: number;
  name: string;
  categoryName: string;
  city: string;
  countryIso: string;
  postalCode: string;
  stateIso: string;
  street: string;
  latitude: number;
  longitude: number;
  phone: string;
  description: string;
  businessHours: unknown[];
  photos: unknown[];
  createdAt: string;
  bizUrl?: string;
}

// CATEGORIES
export interface IFindCategoryResponse {
  id: number;
  name: string;
}

// COUNTRIES
export interface IFindCountryResponse {
  iso: string;
  name: string;
  states: IState[];
}

export interface IState {
  iso: string;
  name: string;
}

export enum ESyncStatus {
  REQUIRING_ACTION = 'REQUIRING_ACTION',
  SYNCED = 'SYNCED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  DISABLED = 'DISABLED',
  // PROCESSING = 'processing',
  // ERROR = 'error',
  // DISABLED = 'oped-out',
}

export enum EGridReportStatus {
  COMPLETED = 'COMPLETED',
  PROCESSING = 'PROCESSING',
}

export type IGetRankingAnalyticsResponse = RankingAnalyticsEntry[];

export interface IKeywordObject {
  id: string;
  locationId: string;
  accountId: string;
  keyword: string;
  createdAt: string;
}

export interface IRankItem {
  rank: number;
  latitude: number;
  longitude: number;
}

export interface IGridReportItem {
  id: string;
  locationId: string;
  accountId: string;
  keyword: string;
  keywordObject: IKeywordObject;
  businessName: string;
  businessStreet: string;
  businessCity: string;
  businessState: string;
  businessCountry: string;
  gridSize: number;
  gridDistance: number;
  gridDistanceUnit: string;
  gridDistanceInKm: number;
  ranks: IRankItem[];
  averageRank: number;
  topOneShare: number;
  topTwoShare: number;
  status: EGridReportStatus;
  latitude: number;
  longitude: number;
  placeId: string | null;
  createdAt: string;
}
